export const FONT = {
    FAMILY: 'Arial, Helvetica, sans-serif',
    FAMILY_SECOND: 'DINCondensedRegular, sans-serif',

    WEIGHT_NORMAL: 400,
    WEIGHT_SEMI_BOLD: 400,
    WEIGHT_BOLD: 700,

    SIZE_XXSMALL: 12,
    SIZE_XSMALL: 13,
    SIZE_SMALL: 13,
    SIZE_MEDIUM: 14,
    SIZE_LARGE: 16,
    SIZE_XLARGE: 18,
};

export const COLOR = {
    BASE: {
        PAGE: '#ebebeb',
        DIVIDER: '#e4e5e7',
        SCRIM_LIGHT: 'rgba(0, 0, 0, 0.6)',
        SCRIM_DARK: 'rgba(0, 0, 0, 0.8)',
        SHADOW_SHORT: 'rgba(0, 0, 0, 0.3)',
        SHADOW_LONG: 'rgba(0, 0, 0, 0.5)',
    },
    BRAND: {
        BACKGROUND1: '#ffffff',
        BACKGROUND2: '#cccccc',
        BACKGROUND3: '#ffffff',
        BACKGROUND4: '#343744',
        BACKGROUND5: '#2c2e39',
        BACKGROUND6: '#d81921',
        BACKGROUND7: '#aa0000',
        FOREGROUND1: '#000000',
        FOREGROUND2: '#333333',
        FOREGROUND3: '#636363',
        FOREGROUND4: '#f7f7f7',
        FOREGROUND5: '#ffffff',
        FOREGROUND6: '#ffffff',
        FOREGROUND6_1: '#cccccc',
        FOREGROUND7: '#aa0000',
        ACCENT1: '#d81921',
        ACCENT2: '#739a00',
        ACCENT3: '#7c080b',
        CTA1: 'linear-gradient(to bottom, #9ebe42, #739a00)',
        CTA2: '#d81921',
    },
    SEMANTIC: {
        ERROR1: '#fb4444',
        ERROR2: '#ffd8d8',
        WARNING1: '#fbe044',
        WARNING2: '#fdf3b7',
        SUCCESS1: '#00ba91',
        SUCCESS2: '#bfebe1',
    },
    RESERVED: {
        BLACK: '#2d2d2e',
        WHITE: '#f9f9f9',
        TRANSPARENT: 'rgba(249, 249, 249, 0)',
        ACCENT: '#5990e2',
    },
    HOVER: {
        SUCCESS: '#6d9200',
        ERROR: '#cd171f',
    },
};

export const BASE_PALETTE = {
    FONT_FAMILY: 'Arial, Helvetica, sans-serif',

    FONT_WEIGHT_MEDIUM: {
        fontWeight: 400,
    },
    FONT_WEIGHT_SEMI_BOLD: {
        fontWeight: 400,
    },

    FONT_HEADER4: {
        fontWeight: FONT.WEIGHT_SEMI_BOLD,
        fontSize: FONT.SIZE_MEDIUM,
        textTransform: 'uppercase',
    },

    FILL_PAGE: COLOR.BASE.PAGE,
    FILL_HEADER: COLOR.BRAND.BACKGROUND6,
    FILL_HERO: COLOR.BRAND.BACKGROUND6,
    FILL_SHEET: COLOR.BRAND.BACKGROUND1,
    FILL_POPOVER: COLOR.BRAND.BACKGROUND2,

    FILL_CONTENT_DEFAULT: COLOR.BRAND.BACKGROUND1,
    FILL_CONTENT_PROMINENT: COLOR.BRAND.BACKGROUND6,

    FILL_CARD: COLOR.BRAND.BACKGROUND1,
    FILL_CARD_PROMINENT: COLOR.BRAND.BACKGROUND1,

    FILL_CONTROL_BACKGROUND: '#123456',
    FILL_CONTROL_FILL: '#123456',
    FILL_CONTROL_OUTLINE: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND6}`,
    FILL_CONTROL_FOREGROUND: '#123456',
    FILL_CONTROL_ACCENT: COLOR.BRAND.CTA1,
    FILL_CONTROL_ODDS: COLOR.BRAND.BACKGROUND5,

    FILL_ACCENT_PRIMARY: 'linear-gradient(to bottom, #9ebe42, #739a00)',
    FILL_ACCENT_SECONDARY: '#d81921',
    FILL_ACCENT_FOCUS: '#7c080b',

    FILL_SELECTED_PRIMARY: COLOR.BRAND.CTA1,
    FILL_SELECTED_ODDS: COLOR.BRAND.ACCENT2,

    DEFAULT_PRIMARY_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.RESERVED.WHITE}`,
    DEFAULT_SECONDARY_TEXT: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND4}`,
    TEXT_DEFAULT_TERTIARY: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND4}`,

    TEXT_PROMINENT_PRIMARY: COLOR.RESERVED.WHITE,
    TEXT_PROMINENT_SECONDARY: COLOR.BRAND.FOREGROUND3,
    TEXT_HERO_PRIMARY: COLOR.RESERVED.WHITE,
    TEXT_HERO_SECONDARY: COLOR.BRAND.FOREGROUND3,

    TEXT_ODDS_PRIMARY: '#ffffff',
    TEXT_ODDS_SECONDARY: '#f7f7f7',

    TEXT_ACCENT_PRIMARY: '#ffffff',
    TEXT_ACCENT_SECONDARY: '#ffffff',
    TEXT_ACCENT_FILL: '#d81921',

    TEXT_SELECTED_PRIMARY: COLOR.BRAND.FOREGROUND1,
    TEXT_SELECTED_ODDS: '#ffffff',

    DEFAULT_GENERIC_ACCENT_COLOR: COLOR.BRAND.CTA2,
    DEFAULT_DIVIDER: COLOR.BASE.DIVIDER,

    DEFAULT_BUTTON_BORDER_RADIUS: 4,
    DEFAULT_NOTIFICATION_BORDER_RADIUS: 4,
    DEFAULT_BOX_DECORATION_WITH_SHADOW: true,

    DEFAULT_TILE_COLOR_SCHEME: 'light',
};
